import { translate as t, exists as te } from "./i18nBridge.js";
import DimensionDO = App.Data.DimensionDO;
import VerticalDO = App.Data.VerticalDO;

export function translatePropertyTitle(
	property: VerticalDO | DimensionDO
): string {
	if (!property) {
		return "";
	}

	return t(`properties.${property.name_clean}.title`);
}

export function translatePropertyFamily(
	property: VerticalDO | DimensionDO
): string {
	if (!property) {
		return "";
	}

	return t(`property_families.${property.family_name_clean}.title`);
}

export function translatePropertyFamilyType(
	property: VerticalDO | DimensionDO
): string {
	if (!property) {
		return "";
	}
	return `${translatePropertyTitle(property)} (${translatePropertyFamily(
		property
	)})`;
}

export function ucfirst(str: string): string {
	if (str === "") {
		return str;
	}

	return str.substring(0, 1).toUpperCase() + str.substring(1);
}

export function translateLegend(propertyName: string): string {
	return te(`properties.${propertyName}.title`)
		? t(`properties.${propertyName}.title`)
		: ucfirst(propertyName);
}
